import { useEffect, useState } from "react";
import Footer from "../../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Edit, Trash2, Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminHotelReport() {
  const [bookingData, setBookingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch bookings from API
  const fetchHotelBookings = async () => {
    try {
      const response = await axios.get(`${baseurl}getAllHotelBookings`);
      console.log("API Response:", response.data);

      if (response.data.bookings) {
        setBookingData(response.data.bookings);
      } else {
        setBookingData([]);
      }
    } catch (error) {
      console.error("Error fetching hotel bookings:", error);
      setError("Failed to load bookings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotelBookings();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              
              <AdminBookingNavbar/>

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">Hotel Booking Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading bookings...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Phone</th>
                              <th>Email</th>
                              <th>Agent ID</th>
                              <th>Status</th>
                              <th>Created At</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bookingData.length > 0 ? (
                              bookingData.map((booking, index) => (
                                <tr key={booking.id}>
                                  <td>{index + 1}</td>
                                  <td>{booking.firstname}</td>
                                  <td>{booking.lastname}</td>
                                  <td>{booking.phoneno}</td>
                                  <td>{booking.email}</td>
                                  <td>{booking.agent_name}</td>
                                  <td>
  <span className={`badge 
    ${booking.status === "active" ? "bg-warning" : 
      booking.status === "complete" ? "bg-success" : 
      "bg-danger"
    }`}>
    {booking.status}
  </span>
</td>

                                  <td>{new Date(booking.created_at).toLocaleString()}</td>
                                  <td>
                                    <span className="btn2 me-2" title="Edit">
                                      <Eye size={15} />  
                                    </span>
                                    
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  No bookings found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminHotelReport;
